import { useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys, type StatisticPeriod } from '../api/dashboard.api';

export function useMDWorkQuality(period: StatisticPeriod) {
  return useQuery({
    queryKey: dashboardQueryKeys.mdWorkQuality(period),
    queryFn: () => dashboardApi.getMDWorkQuality(period),
  });
}
